import { any } from 'util/arrays'

function selectBase(state) {
  return state.reports
}

export function selectAreAnyBusinessHoursSet(state) {
  return any(day => day.enabled, Object.values(selectBusinessHours(state).days))
}

export function selectBusinessHours(state) {
  return selectBase(state).businessHours
}

export function selectBusinessHoursTimezone(state) {
  return selectBusinessHours(state).timezone
}
